import OriginLocation from '../enums/OriginLocation';

export default function originLocation(input: string): string | null {

    switch(input) {

        case OriginLocation.OS: return 'OS';
        case OriginLocation.WAD: return 'WAD';
        case OriginLocation.GERMANY: return 'Duitsland';
        case OriginLocation.IRELAND: return 'Ierland';
        default: return null;
    }
}
